import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_665214ce-6ff3-44fe-8494-ab0b47b80e74/artifacts/nggtror1_logo.png";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Specialised & Experienced In' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav 
      data-testid="navbar"
      className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link 
            to="/" 
            data-testid="logo-link"
            className="flex items-center gap-3 hover:opacity-80 transition-opacity"
          >
            <img 
              src={LOGO_URL} 
              alt="NJ Steel Fabrications" 
              className="h-14 w-auto"
            />
            <div className="hidden sm:block">
              <p className="font-heading font-bold text-xl tracking-tight text-steel-dark uppercase">
                NJ Steel
              </p>
              <p className="font-body text-xs text-steel-gray -mt-1">
                Fabrications
              </p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.path === '/' ? 'home' : link.path.slice(1)}`}
                className={`font-heading font-bold text-base uppercase tracking-wide transition-colors ${
                  isActive(link.path)
                    ? 'text-primary border-b-3 border-primary pb-1'
                    : 'text-steel-dark hover:text-primary'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-button"
            className="md:hidden p-2 text-steel-dark"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div 
            data-testid="mobile-menu"
            className="md:hidden pb-6 animate-fade-in"
          >
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`mobile-nav-link-${link.path === '/' ? 'home' : link.path.slice(1)}`}
                  className={`font-body font-medium py-2 transition-colors ${
                    isActive(link.path)
                      ? 'text-primary'
                      : 'text-steel-gray hover:text-primary'
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
